import React, {useEffect, useState} from 'react';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../../api';
import DataTable from "datatables.net-dt";
import "jquery";
import cogoToast from "cogo-toast";
import {
    getPageInsight,
    getPostStat,
    getTask,
    getUser,
    getXAccountInsight,
    influencerStats,
    userReport
} from "../../../api/app";
import {truncate} from "../../../utils/trunate";
import moment from "moment";
import formatNumber from "../../../utils/formatNumber";
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal from 'bootstrap/js/dist/modal';
const $ = window.$;

let filter = {};

const searchableFields = [
    { field: 'first_name', isNumeric: false },
    { field: 'last_name', isNumeric: false },
    { field: 'full_name', isNumeric: false },
    { field: 'contact_number', isNumeric: false },
    { field: 'agent.name', isNumeric: true },
    { field: 'agent.username', isNumeric: true },
    { field: 'id_number', isNumeric: false }
];

const Influencer = (props) => {

    document.title = "Influencer";

    const token = localStorage.getItem('jwtToken');
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [resetStats, setResetStats] = useState(new Date().getTime());
    const [resetSocial, setResetSocial] = useState(new Date().getTime());
    const [pages, setPages] = useState([]);
    const [socialId, setSocialId] = useState(null);
    const [twiiterId, setTwiiterId] = useState(null);
    const [tiktok, setTiktok] = useState(null);
    const [twitter, setTwitter] = useState(null);

    useEffect(() => {
        getUser(props.match.params.id).then((response) => {
            if (!response.error) {
                filter = {
                    user: `ObjectId(${props.match.params.id})`
                }
                setUserData(response.payload.user);
                setLoading(false);
            }
        });
    }, []);

    useEffect(() => {
        influencerStats(props.match.params.id).then((response) => {
            if(!response.error) {
                $("#total-views").text(formatNumber(response.payload.total_reach));
                $("#total-interactions").text(formatNumber(response.payload.total_reactions));
                $("#total-engagement").text(formatNumber(response.payload.total_engagements));
                $("#total-task").text(formatNumber(response.payload.completed_tasks));
            }
        });
    }, [resetStats]);

    useEffect(() => {
        userReport(props.match.params.id).then((response) => {
            $("#total-assignment").text(formatNumber(response.payload.total_task));
            $("#total-users").text(formatNumber(response.payload.total_submission));
            setTiktok(response.payload?.tiktok);
            setTwitter(response.payload?.twitter?.metadata || null);
            setTwiiterId(response.payload?.twitter?._id);
            setPages(response.payload?.social?.pages);
            setSocialId(response.payload?.social?._id);
        });
    }, [resetSocial]);

    useEffect(() => {
        let table = new DataTable('#admin', {
            responsive: true,
            dom: 'tip',
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Task Data</p>'
            },
            searching: false,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "task",
                        searchableFields,
                        filter: {
                            user: `ObjectId(${props.match.params.id})`
                        },
                        populate: [
                            {
                                path: "assignment",
                                model: "assignment"
                            }
                        ],
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                { "data": "raw" },
                { "data": "raw", "className": "align-middle" },
                { "data": "raw", "className": "align-middle" },
                { "data": "raw", "className": "align-middle" },
                { "data": "raw", "className": "align-middle" }
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return `<div>
                                    <span class="text-capitalize tx-primary" style="color: black">${data.assignment.subject}</span>
                                    <p class="tx-secondary" style="color: #9893AE">${truncate(data.description, 200)}</p>
                                    <div class="d-flex align-items-center">
                                        <span style="margin-right: 16px"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.98633 12.2333L7.05299 13.8333C7.31966 14.1 7.91966 14.2333 8.31966 14.2333H10.853C11.653 14.2333 12.5197 13.6333 12.7197 12.8333L14.3197 7.96667C14.653 7.03333 14.053 6.23333 13.053 6.23333H10.3863C9.98633 6.23333 9.65299 5.9 9.71966 5.43333L10.053 3.3C10.1863 2.7 9.78633 2.03333 9.18633 1.83333C8.65299 1.63333 7.98633 1.9 7.71966 2.3L4.98633 6.36667" stroke="#9893AE" stroke-width="1.5" stroke-miterlimit="10"/>
                                            <path d="M1.58789 12.2333V5.70002C1.58789 4.76668 1.98789 4.43335 2.92122 4.43335H3.58789C4.52122 4.43335 4.92122 4.76668 4.92122 5.70002V12.2333C4.92122 13.1667 4.52122 13.5 3.58789 13.5H2.92122C1.98789 13.5 1.58789 13.1667 1.58789 12.2333Z" stroke="#9893AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            ${data?.meta?.facebook?.likes ? data.meta.facebook.likes : 0}
                                        </span>
                                    
                                        <span style="margin-right: 16px"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.6775 11.7409C9.62558 12.5569 8.33217 12.9998 7.00089 13C5.8642 13.0017 4.75061 12.6791 3.79089 12.07L1.0009 13L1.93089 10.21C1.21866 9.08528 0.900716 7.75561 1.02711 6.43035C1.15351 5.10509 1.71706 3.8595 2.62906 2.88968C3.54106 1.91985 4.7497 1.28088 6.0647 1.07336C7.3797 0.865832 8.72637 1.10154 9.89271 1.74337C11.0591 2.3852 11.9788 3.3967 12.5072 4.61863C13.0356 5.84056 13.1426 7.20352 12.8113 8.49293C12.4801 9.78233 11.7294 10.925 10.6775 11.7409Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            ${data?.meta?.facebook?.comments ? data.meta.facebook.comments : 0}
                                        </span>
                                    
                                        <span><svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.75 5C0.75 5 2.75 0.75 7 0.75C11.25 0.75 13.25 5 13.25 5C13.25 5 11.25 9.25 7 9.25C2.75 9.25 0.75 5 0.75 5Z" stroke="#9893AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7 6.25C7.69036 6.25 8.25 5.69036 8.25 5C8.25 4.30964 7.69036 3.75 7 3.75C6.30964 3.75 5.75 4.30964 5.75 5C5.75 5.69036 6.30964 6.25 7 6.25Z" fill="#9893AE" stroke="#9893AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            ${data?.meta?.facebook?.reach ? data.meta.facebook.reach : 0}
                                        </span>
                                    </div>
                                </div>`;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return {
                            pending : `<span class="badge bg-purple text-white">Pending</span>`,
                            awaiting : `<span class="badge bg-warning text-black">Posted</span>`,
                            completed : `<span class="badge bg-blue text-black">Completed</span>`,
                            rejected : `<span class="badge bg-danger text-black">Danger</span>`
                        }[data.status];
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `<img src="assets/img/facebook-icon.png" height="36" alt="facebook-icon"/>`
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return moment(data.date.iso).format("Do, MMM, YYYY");
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return `<div class="dropdown">
                                    <a href="javascript:void(0)" class="nav-link text-center" data-bs-toggle="dropdown">
                                    <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1C2.26522 1 2.51957 1.10536 2.70711 1.29289C2.89464 1.48043 3 1.73478 3 2C3 2.26522 2.89464 2.51957 2.70711 2.70711C2.51957 2.89464 2.26522 3 2 3C1.73478 3 1.48043 2.89464 1.29289 2.70711C1.10536 2.51957 1 2.26522 1 2C1 1.73478 1.10536 1.48043 1.29289 1.29289Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1.29289 8.29289C1.48043 8.10536 1.73478 8 2 8C2.26522 8 2.51957 8.10536 2.70711 8.29289C2.89464 8.48043 3 8.73478 3 9C3 9.26522 2.89464 9.51957 2.70711 9.70711C2.51957 9.89464 2.26522 10 2 10C1.73478 10 1.48043 9.89464 1.29289 9.70711C1.10536 9.51957 1 9.26522 1 9C1 8.73478 1.10536 8.48043 1.29289 8.29289Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1.29289 15.2929C1.48043 15.1054 1.73478 15 2 15C2.26522 15 2.51957 15.1054 2.70711 15.2929C2.89464 15.4804 3 15.7348 3 16C3 16.2652 2.89464 16.5196 2.70711 16.7071C2.51957 16.8946 2.26522 17 2 17C1.73478 17 1.48043 16.8946 1.29289 16.7071C1.10536 16.5196 0.999999 16.2652 0.999999 16C0.999999 15.7348 1.10536 15.4804 1.29289 15.2929Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    </a>
                                      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a class="dropdown-item text-secondary insight-report" href="#"><i class="fa fa-eye"></i> View Insight</a></li>
                                        <li><hr class="dropdown-divider"></li>
                                        <li><a class="dropdown-item text-danger delete_assignment" href="#"><i class="fa fa-trash"></i> Delete Task</a></li>
                                      </ul>
                                </div>`
                    },
                    "targets": 4
                }
            ]
        });

        table.on('click', '.insight-report', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();

            if(extract_td?.raw?.status === "pending") return cogoToast.error("No report was submitted for this assignment", {
                position: "top-right",
                hideAfter: 3
            });

            let {hide} = cogoToast.loading('Please wait... contacting to facebook server.', {
                position: "top-right",
                hideAfter: 0
            });

            getTask(extract_td?.raw?._id).then((responseData) => {
                if(!responseData.error) {
                    getPostStat(responseData.payload._id).then((response) => {
                        hide();
                        if(!response.error) {
                            const {likes, comments, shares, reactions, engagements, page} = response.payload;

                            $("#total-likes").text(likes);
                            $("#total-comments").text(comments);
                            $("#total-shares").text(shares);
                            $("#total-reactions").text(reactions);
                            $("#total-engagements").text(engagements);

                            //Page Info
                            $("#page-name-1").text(page.name);
                            $("#page-category-1").text(page.category);
                            $("#page-follower-1").text(formatNumber(page.followers_count));
                            $('#page-logo-1').attr('src', page.picture.data.url);
                            $('#page-link-1').attr('href', `https://www.facebook.com/${page.id}`);
                            $('#post-link-1').attr('href', responseData.payload.url);

                            const modal = Modal.getOrCreateInstance($('#modalInsightReport')[0], {backdrop: 'static', focus: false});
                            modal.show();
                        }
                    });
                } else {
                    hide();
                }
            });
        })

        return () => {
            table.destroy();
        }
    }, []);

    const facebookPageInsight = (data) => {
        let {hide} = cogoToast.loading('Please wait... contacting to facebook server.', {
            position: "top-right",
            hideAfter: 0
        });

        getPageInsight(socialId, data.id).then((response) => {
            hide();
            if(!response.error) {
                $("#page-name").text(data.name);
                $("#page-id").text(data.id);
                $('#page-picture-logo').attr('src', response.payload.picture);
                $("#page-total-follower").text(formatNumber(response.payload.total_followers));
                $("#page-total-engagement").text(formatNumber(response.payload.total_engagement));
                $("#page-total-daily").text(formatNumber(response.payload.daily_reach));
                $("#page-total-weekly").text(formatNumber(response.payload.weekly_reach));
                $("#page-total-monthly").text(formatNumber(response.payload.monthly_reach));
                const offcanvas = Offcanvas.getOrCreateInstance($('#staticBackdrop')[0]);
                offcanvas.show();
            }
        });
    }

    const xAccountInsight = (data) => {
        let {hide} = cogoToast.loading('Please wait... contacting to twitter server.', {
            position: "top-right",
            hideAfter: 0
        });

        getXAccountInsight(twiiterId, data.profile?.id).then((response) => {
            hide();
            if(!response.error) {
                $("#page-name").text(data.profile?.displayName);
                $("#page-id").text(data.profile?.username);
                $('#page-picture-logo').attr('src', response.payload.picture);
                $("#page-total-follower").text(formatNumber(response.payload.total_followers));
                $("#page-total-engagement").text(formatNumber(response.payload.total_engagement));
                $("#page-total-daily").text(formatNumber(response.payload.daily_reach));
                $("#page-total-weekly").text(formatNumber(response.payload.weekly_reach));
                $("#page-total-monthly").text(formatNumber(response.payload.monthly_reach));
                const offcanvas = Offcanvas.getOrCreateInstance($('#staticBackdrop')[0]);
                offcanvas.show();
            }
        });
    }

    return (
        <div className="content-body">
            <div className="d-flex mb-5">
                <div>
                    <div className="d-flex align-items-center">
                        <img style={{marginRight: 16}} src="assets/img/profile.png" height="48" alt="profile"/>
                        <div>
                            <div className="d-flex">
                                <span className="tx-name text-capitalize">{userData?.name}</span>
                                <span className="badge bg-primary bg-green" style={{color: "#4F5F00"}}>Influencer</span>
                            </div>
                            <span className="tx-email">{userData?.mobile_number}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-between">
                <div>
                    <h2>Influencer Page Profile</h2>
                    <h5>Influencer Page Stats & Associated Social Account.</h5>
                </div>
            </div>

            <div className="card card-view mt-3">
                <div style={{padding: 16, paddingBottom: 6}}>
                    <h4 style={{fontSize: 24, color: "black"}}>Insight</h4>
                </div>
                <div className="row" style={{padding: 16, paddingTop: 0}}>
                    <div className="col-md-3">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <path
                                    d="M18 20.5C19.3807 20.5 20.5 19.3807 20.5 18C20.5 16.6193 19.3807 15.5 18 15.5C16.6193 15.5 15.5 16.6193 15.5 18C15.5 19.3807 16.6193 20.5 18 20.5Z"
                                    fill="#5D3EF4"/>
                                <path
                                    d="M27.3372 17.7875C26.6021 15.886 25.326 14.2416 23.6665 13.0576C22.007 11.8735 20.0369 11.2016 17.9997 11.125C15.9626 11.2016 13.9925 11.8735 12.333 13.0576C10.6735 14.2416 9.39733 15.886 8.66223 17.7875C8.61259 17.9248 8.61259 18.0752 8.66223 18.2125C9.39733 20.114 10.6735 21.7584 12.333 22.9424C13.9925 24.1265 15.9626 24.7984 17.9997 24.875C20.0369 24.7984 22.007 24.1265 23.6665 22.9424C25.326 21.7584 26.6021 20.114 27.3372 18.2125C27.3869 18.0752 27.3869 17.9248 27.3372 17.7875ZM17.9997 22.0625C17.1962 22.0625 16.4108 21.8242 15.7427 21.3778C15.0747 20.9315 14.554 20.297 14.2465 19.5547C13.939 18.8123 13.8585 17.9955 14.0153 17.2074C14.172 16.4194 14.559 15.6955 15.1271 15.1274C15.6953 14.5592 16.4191 14.1723 17.2072 14.0156C17.9952 13.8588 18.8121 13.9393 19.5544 14.2467C20.2967 14.5542 20.9312 15.0749 21.3776 15.743C21.824 16.4111 22.0622 17.1965 22.0622 18C22.0606 19.0769 21.632 20.1093 20.8705 20.8708C20.109 21.6323 19.0767 22.0608 17.9997 22.0625Z"
                                    fill="#5D3EF4"/>
                            </svg>
                            <h6 className="mt-2">Views</h6>
                            <div className="d-flex justify-content-between align-items-center">
                                <h1 style={{fontSize: 20}} id="total-views">0</h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <g clip-path="url(#clip0_323_4463)">
                                    <path
                                        d="M18.0013 26.3333C16.8485 26.3333 15.7652 26.1145 14.7513 25.6767C13.7374 25.2389 12.8555 24.6453 12.1055 23.8958C11.3555 23.1464 10.7619 22.2645 10.3246 21.25C9.88741 20.2356 9.66853 19.1522 9.66797 18C9.66741 16.8478 9.8863 15.7645 10.3246 14.75C10.763 13.7356 11.3566 12.8536 12.1055 12.1042C12.8544 11.3547 13.7363 10.7611 14.7513 10.3233C15.7663 9.88557 16.8496 9.66668 18.0013 9.66668C18.4735 9.66668 18.9319 9.7014 19.3763 9.77085C19.8207 9.84029 20.2582 9.9514 20.6888 10.1042C20.8832 10.1736 21.0396 10.2953 21.158 10.4692C21.2763 10.6431 21.3352 10.8339 21.3346 11.0417V12.2292C21.3346 12.6736 21.491 13.0522 21.8038 13.365C22.1166 13.6778 22.4949 13.8339 22.9388 13.8333H23.0013V14.3125C23.0013 14.632 23.1194 14.9097 23.3555 15.1458C23.5916 15.382 23.8694 15.5 24.1888 15.5H25.2513C25.4596 15.5 25.6471 15.5625 25.8138 15.6875C25.9805 15.8125 26.0916 15.9792 26.1471 16.1875C26.2166 16.4792 26.2652 16.7745 26.293 17.0733C26.3207 17.3722 26.3346 17.6811 26.3346 18C26.3346 19.1528 26.1157 20.2361 25.678 21.25C25.2402 22.2639 24.6466 23.1458 23.8971 23.8958C23.1477 24.6458 22.2657 25.2397 21.2513 25.6775C20.2369 26.1153 19.1535 26.3339 18.0013 26.3333ZM18.0013 22.5833C18.8069 22.5833 19.5499 22.3889 20.2305 22C20.911 21.6111 21.4596 21.0833 21.8763 20.4167C21.9596 20.25 21.9527 20.0833 21.8555 19.9167C21.7582 19.75 21.6124 19.6667 21.418 19.6667H14.5846C14.3902 19.6667 14.2444 19.75 14.1471 19.9167C14.0499 20.0833 14.043 20.25 14.1263 20.4167C14.543 21.0833 15.0952 21.6111 15.783 22C16.4707 22.3889 17.2102 22.5833 18.0013 22.5833ZM15.0846 17.1667C15.4319 17.1667 15.7271 17.0453 15.9705 16.8025C16.2138 16.5597 16.3352 16.2645 16.3346 15.9167C16.3341 15.5689 16.2127 15.2739 15.9705 15.0317C15.7282 14.7895 15.433 14.6678 15.0846 14.6667C14.7363 14.6656 14.4413 14.7872 14.1996 15.0317C13.958 15.2761 13.8363 15.5711 13.8346 15.9167C13.833 16.2622 13.9546 16.5575 14.1996 16.8025C14.4446 17.0475 14.7396 17.1689 15.0846 17.1667ZM20.918 17.1667C21.2652 17.1667 21.5605 17.0453 21.8038 16.8025C22.0471 16.5597 22.1685 16.2645 22.168 15.9167C22.1674 15.5689 22.046 15.2739 21.8038 15.0317C21.5616 14.7895 21.2663 14.6678 20.918 14.6667C20.5696 14.6656 20.2746 14.7872 20.033 15.0317C19.7913 15.2761 19.6696 15.5711 19.668 15.9167C19.6663 16.2622 19.788 16.5575 20.033 16.8025C20.278 17.0475 20.573 17.1689 20.918 17.1667ZM24.668 12.1667H23.8346C23.5985 12.1667 23.4007 12.0867 23.2413 11.9267C23.0819 11.7667 23.0019 11.5689 23.0013 11.3333C23.0007 11.0978 23.0807 10.9 23.2413 10.74C23.4019 10.58 23.5996 10.5 23.8346 10.5H24.668V9.66668C24.668 9.43057 24.748 9.23279 24.908 9.07335C25.068 8.9139 25.2657 8.8339 25.5013 8.83335C25.7369 8.83279 25.9349 8.91279 26.0955 9.07335C26.256 9.2339 26.3357 9.43168 26.3346 9.66668V10.5H27.168C27.4041 10.5 27.6021 10.58 27.7621 10.74C27.9221 10.9 28.0019 11.0978 28.0013 11.3333C28.0007 11.5689 27.9207 11.767 27.7613 11.9275C27.6019 12.0881 27.4041 12.1678 27.168 12.1667H26.3346V13C26.3346 13.2361 26.2546 13.4342 26.0946 13.5942C25.9346 13.7542 25.7369 13.8339 25.5013 13.8333C25.2657 13.8328 25.068 13.7528 24.908 13.5933C24.748 13.4339 24.668 13.2361 24.668 13V12.1667Z"
                                        fill="#5D3EF4"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_323_4463">
                                        <rect width="20" height="20" fill="white" transform="translate(8 8)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <h6 className="mt-2">Interactions</h6>
                            <div className="d-flex justify-content-between align-items-center">
                                <h1 style={{fontSize: 20}} id="total-interactions">0</h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <path
                                    d="M18 20.5C19.3807 20.5 20.5 19.3807 20.5 18C20.5 16.6193 19.3807 15.5 18 15.5C16.6193 15.5 15.5 16.6193 15.5 18C15.5 19.3807 16.6193 20.5 18 20.5Z"
                                    fill="#5D3EF4"/>
                                <path
                                    d="M27.3372 17.7875C26.6021 15.886 25.326 14.2416 23.6665 13.0576C22.007 11.8735 20.0369 11.2016 17.9997 11.125C15.9626 11.2016 13.9925 11.8735 12.333 13.0576C10.6735 14.2416 9.39733 15.886 8.66223 17.7875C8.61259 17.9248 8.61259 18.0752 8.66223 18.2125C9.39733 20.114 10.6735 21.7584 12.333 22.9424C13.9925 24.1265 15.9626 24.7984 17.9997 24.875C20.0369 24.7984 22.007 24.1265 23.6665 22.9424C25.326 21.7584 26.6021 20.114 27.3372 18.2125C27.3869 18.0752 27.3869 17.9248 27.3372 17.7875ZM17.9997 22.0625C17.1962 22.0625 16.4108 21.8242 15.7427 21.3778C15.0747 20.9315 14.554 20.297 14.2465 19.5547C13.939 18.8123 13.8585 17.9955 14.0153 17.2074C14.172 16.4194 14.559 15.6955 15.1271 15.1274C15.6953 14.5592 16.4191 14.1723 17.2072 14.0156C17.9952 13.8588 18.8121 13.9393 19.5544 14.2467C20.2967 14.5542 20.9312 15.0749 21.3776 15.743C21.824 16.4111 22.0622 17.1965 22.0622 18C22.0606 19.0769 21.632 20.1093 20.8705 20.8708C20.109 21.6323 19.0767 22.0608 17.9997 22.0625Z"
                                    fill="#5D3EF4"/>
                            </svg>
                            <h6 className="mt-2">Engagements</h6>
                            <div className="d-flex justify-content-between align-items-center">
                                <h1 style={{fontSize: 20}} id="total-engagement">0</h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <path
                                    d="M17.1237 23L21.832 18.2917L20.6237 17.0833L17.1029 20.6042L15.3529 18.8542L14.1654 20.0417L17.1237 23ZM12.9987 26.3333C12.5404 26.3333 12.1481 26.1703 11.822 25.8442C11.4959 25.518 11.3326 25.1255 11.332 24.6667V11.3333C11.332 10.875 11.4954 10.4828 11.822 10.1567C12.1487 9.83055 12.5409 9.66721 12.9987 9.66666H19.6654L24.6654 14.6667V24.6667C24.6654 25.125 24.5023 25.5175 24.1762 25.8442C23.8501 26.1708 23.4576 26.3339 22.9987 26.3333H12.9987ZM18.832 15.5H22.9987L18.832 11.3333V15.5Z"
                                    fill="#5D3EF4"/>
                            </svg>
                            <h6 className="mt-2">Completed tasks</h6>
                            <div className="d-flex justify-content-between align-items-center">
                                <h1 style={{fontSize: 20}} id="total-task">0</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card card-view mt-3">
                <div className="p-3">
                    <h5>Tasks</h5>
                </div>
                <div className="card-body table-responsive p-0">
                    <table id="admin" className="table">
                        <thead>
                        <tr>
                            <th style={{width: "60%"}}>Post Content</th>
                            <th style={{width: "10%"}}>Status</th>
                            <th style={{width: "10%"}}>Platform</th>
                            <th style={{width: "10%"}}>Date</th>
                            <th style={{width: "10%"}}>Actions</th>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>

            <div id="social-account" className="card card-view mt-3" style={{padding: 16, paddingBottom: 0}}>
                <div style={{padding: 16, paddingBottom: 6}}>
                    <h4 style={{fontSize: 24, color: "black"}}>Connected Accounts</h4>
                </div>

                {pages?.length > 0 ? <div className="row mb-3">
                    <h4 className="tx-danger" style={{marginLeft: 16, marginBottom: 16, fontWeight: "bold", fontSize: 16}}>Facebook Connect.</h4>
                    {pages.map((data) => (
                        <div className="col-md-3 mb-3">
                            <a href="javascript:void(0)" className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}} onClick={() => {
                                facebookPageInsight(data);
                            }}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center" style={{width: '90%'}}>
                                        <img src={data.picture.data.url} height="46" width="46" alt="facebook icon" style={{borderRadius: "60%"}}/>
                                        <div>
                                            <h5 style={{fontSize: 15}}>{data.name}</h5>
                                            <h6 style={{fontSize: 12}}>{data.id}</h6>
                                        </div>
                                    </div>
                                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.000156341 1.41L4.58016 6L0.00015594 10.59L1.41016 12L7.41016 6L1.41016 -2.62268e-07L0.000156341 1.41Z"
                                            fill="black"/>
                                    </svg>
                                </div>

                                <hr/>

                                <h6>Followers</h6>
                                <h3>{formatNumber(data.followers_count)}</h3>
                            </a>
                        </div>
                    ))}
                </div> : <div>
                    <h4 className="tx-danger" style={{marginLeft: 16, marginBottom: 16, fontWeight: "bold", fontSize: 16}}>Facebook Connect.</h4>
                    <h6 className="tx-danger" style={{marginLeft: 16, marginBottom: 30}}>No Pages Connected.</h6>
                </div>}

                <hr/>

                {twitter !== null ? <div className="row mb-3">
                    <h4 className="tx-danger" style={{marginLeft: 16, marginBottom: 16, fontWeight: "bold", fontSize: 16}}>X Connect.</h4>
                    <div className="col-md-3 mb-3">
                        <a href="javascript:void(0)" className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}} onClick={() => {
                            xAccountInsight(twitter);
                        }}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center" style={{width: '90%'}}>
                                    <img src={twitter?.profile?.avatarUrl} height="46" width="46" alt="facebook icon" style={{borderRadius: "60%"}}/>
                                    <div>
                                        <h5 style={{fontSize: 15}}>{twitter?.profile?.displayName}</h5>
                                        <h6 style={{fontSize: 12}}>{twitter?.profile?.username}</h6>
                                    </div>
                                </div>
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0.000156341 1.41L4.58016 6L0.00015594 10.59L1.41016 12L7.41016 6L1.41016 -2.62268e-07L0.000156341 1.41Z"
                                        fill="black"/>
                                </svg>
                            </div>

                            <hr/>

                            <h6>Followers</h6>
                            <h3>{formatNumber(twitter?.profile?.followerCount)}</h3>
                        </a>
                    </div>
                </div> : <div>
                    <h4 className="tx-danger" style={{marginLeft: 16, marginBottom: 16, fontWeight: "bold", fontSize: 16}}>X Connect.</h4>
                    <h6 className="tx-danger" style={{marginLeft: 16, marginBottom: 30}}>No X Connected.</h6>
                </div>}
            </div>

            <div className="modal fade" id="modalInsightReport" tabIndex="-1" role="dialog"
                 aria-labelledby="confirmation" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div>
                                <h5 className="modal-title">Stats Report</h5>
                                <p className="text-muted mb-0" style={{fontSize: 13}}>Overview of your post performance</p>
                            </div>
                            <a href="javascript:void(0)" role="button" data-bs-dismiss="modal" aria-label="Close" onClick={() => {setResetStats(new Date().getTime())}}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="32" height="32" rx="16" fill="black"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.5272 12.5287C12.6522 12.4037 12.8218 12.3335 12.9986 12.3335C13.1753 12.3335 13.3449 12.4037 13.4699 12.5287L15.9986 15.0573L18.5272 12.5287C18.5887 12.465 18.6623 12.4142 18.7436 12.3793C18.825 12.3443 18.9124 12.3259 19.001 12.3252C19.0895 12.3244 19.1773 12.3413 19.2592 12.3748C19.3411 12.4083 19.4156 12.4578 19.4782 12.5204C19.5407 12.583 19.5902 12.6574 19.6238 12.7394C19.6573 12.8213 19.6742 12.9091 19.6734 12.9976C19.6726 13.0861 19.6542 13.1736 19.6193 13.2549C19.5843 13.3363 19.5336 13.4098 19.4699 13.4713L16.9412 16L19.4699 18.5287C19.5913 18.6544 19.6585 18.8228 19.657 18.9976C19.6555 19.1724 19.5854 19.3396 19.4618 19.4632C19.3382 19.5868 19.171 19.6569 18.9962 19.6585C18.8214 19.66 18.653 19.5928 18.5272 19.4713L15.9986 16.9427L13.4699 19.4713C13.3442 19.5928 13.1758 19.66 13.001 19.6585C12.8262 19.6569 12.6589 19.5868 12.5353 19.4632C12.4117 19.3396 12.3416 19.1724 12.3401 18.9976C12.3386 18.8228 12.4058 18.6544 12.5272 18.5287L15.0559 16L12.5272 13.4713C12.4022 13.3463 12.332 13.1768 12.332 13C12.332 12.8232 12.4022 12.6537 12.5272 12.5287Z" fill="white"/>
                                </svg>
                            </a>
                        </div>

                        <div className="modal-body pt-3">
                            {/* Stats Cards */}
                            <div className="row g-3 mb-4">
                                <div className="col-6 col-lg-3">
                                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                                        <div className="insight-icon-wrap bg-purple-light mb-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9525 20.3914 19.4872L21.4914 12.4872C21.7688 10.671 20.3768 9 18.5404 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.9168 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z" stroke="#5D3EF4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <h3 id="total-likes" className="fw-bold mb-1" style={{fontSize: 28, color: 'black'}}>0</h3>
                                        <p style={{fontSize: 13, color: '#9893AE'}}>Likes</p>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                                        <div className="insight-icon-wrap bg-blue-light mb-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.5 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V10.5M8 10H16M8 14H12M18 21V15M15 18H21" stroke="#00B4D8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <h3 id="total-comments" className="fw-bold mb-1"
                                            style={{fontSize: 28, color: 'black'}}>0</h3>
                                        <p style={{fontSize: 13, color: '#9893AE'}}>Comments</p>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                                        <div className="insight-icon-wrap bg-green-light mb-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 12V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V12M12 2V16M12 2L8 6M12 2L16 6" stroke="#7C9500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <h3 id="total-shares" className="fw-bold mb-1" style={{fontSize: 28, color: 'black'}}>0</h3>
                                        <p style={{fontSize: 13, color: '#9893AE'}}>Shares</p>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                                        <div className="insight-icon-wrap bg-red-light mb-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="#ED1414" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <h3 id="total-reactions" className="fw-bold mb-1" style={{fontSize: 28, color: 'black'}}>0</h3>
                                        <p style={{fontSize: 13, color: '#9893AE'}}>Reactions</p>
                                    </div>
                                </div>
                            </div>

                            {/* Engagement */}
                            <div className="card card-view p-3 mb-3">
                                <p style={{
                                    fontSize: 12,
                                    color: '#9893AE',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.08em'
                                }}>Total Engagement</p>
                                <h2 id="total-engagements"
                                    style={{fontSize: 32, fontWeight: 700, color: 'black'}}>0</h2>
                            </div>

                            <hr/>

                            {/* Page Info */}
                            <div className="card card-view p-3">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <p style={{
                                        fontSize: 12,
                                        color: '#9893AE',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.08em'
                                    }} className="mb-0">Page Info</p>
                                    <div className="d-flex gap-2">
                                        <a href="#" target="_blank" rel="noreferrer" id="post-link-1"
                                           className="d-flex align-items-center gap-1"
                                           style={{fontSize: 13, color: '#5D3EF4', fontWeight: 500}}>
                                            View Post
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14"
                                                    stroke="#5D3EF4" strokeWidth="2" strokeLinecap="round"
                                                    strokeLinejoin="round"/>
                                            </svg>
                                        </a>
                                        <span style={{color: '#EAE9F3'}}>|</span>
                                        <a href="#" target="_blank" rel="noreferrer" id="page-link-1"
                                           className="d-flex align-items-center gap-1"
                                           style={{fontSize: 13, color: '#5D3EF4', fontWeight: 500}}>
                                            View Page
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14"
                                                    stroke="#5D3EF4" strokeWidth="2" strokeLinecap="round"
                                                    strokeLinejoin="round"/>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center gap-3">
                                        <img id="page-logo-1" src="" alt="logo"
                                             style={{
                                                 width: 48,
                                                 height: 48,
                                                 borderRadius: 30,
                                                 objectFit: 'cover',
                                                 background: '#F4F2FC'
                                             }}/>
                                        <div>
                                            <p id="page-name-1" className="fw-semibold mb-0"
                                               style={{fontSize: 15, color: 'black'}}>Name</p>
                                            <p id="page-category-1" style={{fontSize: 12, color: '#9893AE'}}
                                               className="mb-0">Category</p>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <p style={{fontSize: 12, color: '#9893AE'}} className="mb-0">Followers</p>
                                        <p id="page-follower-1" className="fw-bold mb-0"
                                           style={{fontSize: 16, color: 'black'}}>0</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="offcanvas offcanvas-end" data-bs-backdrop="static" tabIndex="-1" id="staticBackdrop" aria-labelledby="staticBackdropLabel">
                <div className="offcanvas-body" id="social-account">
                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center" style={{width: '90%'}}>
                                <img id="page-picture-logo" src="assets/img/profile.png" height="46" width="46" alt="facebook icon" style={{borderRadius: "60%"}}/>
                                <div className="align-items-center">
                                    <h5 id="page-name" style={{fontSize: 15}}>Name</h5>
                                    <h6 style={{fontSize: 12}} id="page-id">---</h6>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <h6>Followers</h6>
                        <h3 id="page-total-follower">0</h3>
                    </div>

                    <div className="card card-view p-3 mt-2" style={{backgroundColor: "#F7F5FF"}}>
                        <h6>Total Engagement (Reach Based)</h6>
                        <h3 id="page-total-engagement">0</h3>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div className="card card-view p-3 mt-2" style={{backgroundColor: "#F7F5FF", width: "100%"}}>
                            <h6>Daily Reach</h6>
                            <h3 id="page-total-daily">0</h3>
                        </div>
                        <div className="card card-view p-3 mt-2" style={{backgroundColor: "#F7F5FF", width: "100%"}}>
                            <h6>Weekly Reach</h6>
                            <h3 id="page-total-weekly">0</h3>
                        </div>
                    </div>

                    <div className="card card-view p-3 mt-2" style={{backgroundColor: "#F7F5FF"}}>
                        <h6>28-Day Reach</h6>
                        <h3 id="page-total-monthly">0</h3>
                    </div>
                </div>
                <div className="offcanvas-footer border-top p-3 d-grid" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => setResetSocial(new Date().getTime())}>
                    <button className="btn btn-secondary">
                        Close
                    </button>
                </div>
            </div>
        </div>
    )
};

export default Influencer;
